export default "__VITE_ASSET__372c2346__"